import React from 'react';

import TagManager from 'react-gtm-module';

const gtmScriptUrl = 'https://www.googletagmanager.com/gtm.js';

function useGTM(gtmContainerId?: string) {
  React.useEffect(() => {
    // check for existing GTM script for preventing double initialization
    const scriptExists = Array.from(document.scripts).some((script) => {
      if (!script.src) return false;
      const url = new URL(script.src, window.location.origin);
      return url.href.includes(gtmScriptUrl) && url.searchParams.get('id') === gtmContainerId;
    });

    if (scriptExists) return;
    if (!gtmContainerId) return;

    const tagManagerArgs = { gtmId: gtmContainerId };
    TagManager.initialize(tagManagerArgs);
  }, [gtmContainerId]);
}

export { useGTM };
